// import {
//     Delete,
//     Save
//   } from "@mui/icons-material";
//   import VisibilityIcon from '@mui/icons-material/Visibility';
//   import {
//     Autocomplete,
//     Backdrop,
//     Button,
//     Divider,
//     Grid,
//     IconButton,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TextField,
//     Typography,
//   } from "@mui/material";
//   import DeleteIcon from '@mui/icons-material/Delete'
//   import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
//   import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//   import axios from "axios";
//   import dayjs from "dayjs";
//   import { useFormik } from "formik";
//   import _ from "lodash";
//   import moment from "moment";
//   import React, { useEffect, useState } from "react";
//   import { Helmet } from "react-helmet-async";
//   import { useDispatch } from "react-redux";
//   import { useNavigate } from "react-router-dom";
//   import * as yup from "yup";
//   import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
//   import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
//   import ExpModalTable from "../../../../../components/utils/modalTable/expenseTable";
//   import { useStyle } from "../../outlets/style";
// import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
//   const DummyWh = () => {
//     const classes = useStyle();
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const outletId = localStorage.getItem("outlet_id");
//     const [open, setOpen] = useState(false);
//     const [openTable, setOpenTable] = useState(false);
//     const [rowData, setRowData] = useState(null)
//     const [isEdit, setIsEdit] = useState(false);
//     const [acHeadData, setAcHeadData] = useState([]);
//     const [subAcHeadData, setSubAcHeadData] = useState([]);
//     const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//     const [totalFlag , setTotalFlag] = useState(false)
//     // Initial Values for post Data
//     const sendData = {
//       docdate: "",
//       accid: 0,
//       amount: 0,
//       remarks: "",
//       company_id: 1,
//       outlet_expences_details: [],
//     };
//     const [docNo, setDocNo] = useState("");
//     const [selectedRow, setSelectedRow] = useState("");
//     const pageOption = [10, 25, 50, 100];
//     const [search, setSearch] = useState("");
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(100);
//     // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     const [pageCount, setPageCount] = useState(0);
//     const [tableData, setTableData] = useState([]);
//     const [activeId, setActiveId] = useState(null);
//     const [data, setData] = useState([]);
//     const [expDataLine , setExpDataLine] = useState([])
//     const wareHouseId = localStorage.getItem('userId')
//   const [openDialog, setOpenDialog] = useState(false)

//     const [poDetails, setPoDetails] = useState({
//       docDate: moment().format(),
//       acHead: null,
//       subAcHead: null,
//       amount: "",
//       remarks: "",
//       fromDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
//       toDate: moment().format("YYYY-MM-DD"),
//     });
//     const [tablePostData, setTablePostData] = useState({
//       headName: null,
//       subHeadName: null,
//       amount: "",
//       remarks: "",
//       headId: null,
//       subHeadId: null,
//     });
//     const [postData, setPostData] = useState([]);
  
//     const initialPoDetails = {
//       docDate: moment().format(),
//       // subAcHead:null,
//       acHead: null,
//       amount: "",
//       remarks: "",
//       fromDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
//       toDate: moment().format("YYYY-MM-DD"),
//     };
//     const validationSchema = yup.object({
//       headName: yup.object().required(),
//       subName: yup.object().required(),
//       amount: yup
//         .string()
//         .matches(/^\S.*$/, "Empty space not allowed!")
//         .required("This field can't be empty!"),
//       remarks: yup.string().notRequired("This field can't be empty!"),
//     });
  
//     const formik = useFormik({
//       initialValues: {
//         headName: null,
//         subName: null,
//         amount: "",
//         remarks: "",
//       },
//       validationSchema: validationSchema,
//       onSubmit: addTable,
//     });
//     const resetPoDetails = () => {
//       setPoDetails(initialPoDetails);
//     };
//     function addTable() {
//       const arr = [...data];
//       const selectedHead = acHeadData.find(
//         (head) => head.id === formik.values.headName.id
//       );
//       const selectedSubHead = subAcHeadData.find(
//         (subHead) => subHead.id === formik.values.subName.id
//       );
//       const newRemarks = formik.values.remarks;
  
//       const objData = {
//         docdate: moment().format("YYYY-MM-DD"),
//         accid: formik.values.headName.id,
//         accname: selectedHead ? selectedHead.acname : "",
//         amount: parseFloat(formik.values.amount),
//         remarks: newRemarks,
//         company_id:1,
//         warehouse_id:1,
//         expences_details: [
//           {
//             docdate: "2024-05-30",
//             accid: formik.values.headName.id,
//             sub_acc_id: formik.values.subName.id,
//             amount: parseFloat(formik.values.amount),
//             sub_acc_name: selectedSubHead ? selectedSubHead.sub_account_name : "",
//           },
//         ],
//       };
  
//       // Check if the head account already exists
//       const existingHeadIndex = arr.findIndex(
//         (val) => val.accid == objData.accid
//       );
  
//       if (existingHeadIndex === -1) {
//         // Head account doesn't exist, add new entry
//         arr.push(objData);
//       } else {
//         // Head account exists, check for sub-account
//         const existingSubIndex = arr[
//           existingHeadIndex
//         ].expences_details.findIndex(
//           (item) => item.sub_acc_id == objData.expences_details[0].sub_acc_id
//         );
  
//         if (existingSubIndex === -1) {
//           // Sub-account doesn't exist, add new sub-account to the existing head
//           arr[existingHeadIndex].expences_details.push(
//             objData.expences_details[0]
//           );
//         } else {
//           // Sub-account exists, add the amount to the existing amount
//           arr[existingHeadIndex].expences_details[existingSubIndex].amount +=
//             objData.expences_details[0].amount;
//         }
  
//         // Update the remarks for the head account and all its sub-accounts
//         arr[existingHeadIndex].remarks = newRemarks;
//         arr[existingHeadIndex].expences_details.forEach((sub) => {
//           sub.remarks = newRemarks;
//         });
  
//         // Update the main amount to reflect the total of all sub-accounts
//         arr[existingHeadIndex].amount = arr[
//           existingHeadIndex
//         ].expences_details.reduce((total, item) => total + item.amount, 0);
//       }
  
//       setData(arr);
//       formik.resetForm();
//       console.log(arr);
//     }
  
//     const onCreate = () => {
//       setOpen(true);
//       setIsEdit(false);
//     };
//     const onEdit = (row) => {
//       console.log(row);
//       setExpDataLine(row.expenseLine)
//       console.log(row.expenseLine)
//       setOpenTable(true)
//       setRowData(row)
//       // const accData = _.filter(acHeadData, (val) => val.id === row.accid).map(
//       //   (val) => val
//       // );
//       // const amnt = row.amount;
//       // const remarks = row.remarks;
//       // const rowDate = row.docDate;
//       // setDocNo(row.docNo1);
//       // //   console.log(accData)
//       // setIsEdit(true);
//       // setPoDetails((prev) => ({
//       //   ...prev,
//       //   acHead: accData[0],
//       //   amount: amnt,
//       //   remarks: remarks,
//       //   docDate: moment(rowDate).format(),
//       // }));
//       // setOpen(true);
//       // setActiveId(row.id);
//     };
//     const columns = [
//       {
//         field: "sno",
//         headerName: "S.no",
//         minWidth: 70,
//         headerAlign: "center",
//         align: "center",
//         sortable: false,
//       },
//       {
//         field: "docNo",
//         headerName: "Bill No",
//         minWidth: 200,
//         headerAlign: "left",
//         align: "left",
//         sortable: false,
//       },
//       {
//         field: "docDates",
//         headerName: "Bill Date",
//         minWidth: 170,
//         headerAlign: "left",
//         align: "left",
//         sortable: false,
//       },
//       {
//         field: "acName",
//         headerName: "Expense Name",
//         minWidth: 190,
//         flex:1,
//         headerAlign: "left",
//         align: "left",
//         sortable: false,
//       },
//       // {
//       //   field: "sub_account_name",
//       //   headerName: "Expense Sub Name",
//       //   minWidth: 130,
//       //   headerAlign: "left",
//       //   align: "left",
//       //   sortable: false,
//       // },
//       {
//         field: "amount",
//         headerName: "Amount",
//         minWidth: 170,
//         headerAlign: "left",
//         align: "left",
//         sortable: false,
//       },
//       {
//         field: "remarks",
//         headerName: "Remarks",
//         minWidth: 200,
//         headerAlign: "left",
//         align: "left",
//         sortable: false,
//       },
//       {
//         field: "action",
//         headerName: "Action",
//         minWidth: 200,
//         headerAlign: "center",
//         align: "center",
//         editable: false,
//         sortable: false,
//         disableColumnMenu: true,
//         disableExport: true,
//         renderCell: (params) => {
//           const isCurrentDate = moment(params.row.docDate).isSame(
//             moment(),
//             "day"
//           );
//           return (
//             <div className="flex justify-center w-full">
//               {/* <IconButton
//                 onClick={() => onEdit(params.row)}
//                 disabled={!isCurrentDate}
//               >
//                 <VisibilityIcon 
//                   sx={{ color: isCurrentDate ? "#1972d2" : "grey", fontSize: 22 }}
//                 />
//               </IconButton> */}
//                <IconButton
//                 onClick={() => onEdit(params.row)}
//               >
//                 <VisibilityIcon 
//                   sx={{  fontSize: 22 }}
//                 />
//               </IconButton>
//               <IconButton onClick={() => OnDelete(params.row)}>
//                     <DeleteIcon sx={{color:"red",fontSize:22}}/>
//                   </IconButton>
//             </div>
//           );
//         },
//       },
//     ];
//     const rows = _.map(tableData, (val, idx) => ({
//       id: val.id,
//       sno: ++idx,
//       docNo: val.docno
//         .replace("_", "/")
//         .replace("_", "-")
//         .replace("_", "/")
//         .replace("_", "/") || "-",
//       documentNo: val.docno ,
//       docDates: moment(val.docdate).format("DD-MM-YYYY"),
//       documentDate: moment(val.docdate).format("DD-MM-YYYY"),
//       docDate: moment(val.docdate).format("YYYY-MM-DD"),
//       accid: val.accid || "-",
//       amount: val.amount || "-",
//       tot_amt:val.amount  || "",
//       remarks: val.remarks || "-",
//       acName: val.account_name || "-",
//       sub_account_name:val.sub_account_name || "-",
//       expenseLine:val.expences_lines

//     }));
//     const tableHeadData = [
//       { id:1, label: "S No" },
//       { id:2, label: "Date" },
//       { id:3 , label:"Sub Account Name"},
//       { id:4 , label:"Amount"},
//     ];
//     console.log(expDataLine)
//     const tableBodyData = _.map(expDataLine, (val,idx) => ({
//       id:idx,
//       sNo:idx+1,
//       name:moment(val.created_at).format('DD-MM-YYYY'),
//       Mrp:val.sub_account_name,
//       gstAmnt:val.amount,
//       Rate:val.rate,
//       totalAmount : parseFloat( val.qty * val.rate ).toFixed(2)
//     }))
//     const props = {
//       rows: rows,
//       columns: columns,
//       search: search,
//       setSearch: setSearch,
//       page: page,
//       setPage: setPage,
//       rowsPerPage: rowsPerPage,
//       setRowsPerPage: setRowsPerPage,
//       pageCount: pageCount,
//       pageOption: pageOption,
//     };
//     function OnDelete(row){
//       console.log("Delete clicked, id is:", row);
//       setOpenDialog(true)
//       setActiveId(row)
//       console.log("Dialog state (openDialog):", true);
//       console.log("ActiveId set to:", row);
//     }
//     const handleAutocompleteChange = (newValue) => {
//       // Do something with the selected value (newValue)
//       // For example, update the state (poDetails.acHead) or dispatch an action
//       setPoDetails((prevState) => ({ ...prevState, acHead: newValue }));
//       // Additional logic or actions can be added here
//     };
//     const handleAutocompleteChangeSub = (newValue) => {
//       setPoDetails((prevState) => ({ ...prevState, subAcHead: newValue }));
//     };
//     const handleChange = (e, name) => {
//       // console.log(e , name)
//       if (name === "docDate") {
//         setPoDetails((prevState) => ({
//           ...prevState,
//           [name]: dayjs(e).format(),
//         }));
//       } else if (name === "fromDate" || name === "toDate") {
//         setPoDetails((prevState) => ({
//           ...prevState,
//           [name]: dayjs(e).format("YYYY-MM-DD"),
//         }));
//       } else {
//         setPoDetails((prevState) => ({ ...prevState, [name]: e }));
//       }
//     };
//     const getSupplierData = () => {
//       axios
//         .get(`/v1/accountmaster`)
//         .then((res) => {
//           setAcHeadData(res.data);
//         })
//         .catch((err) => {
//           console.log(err);
//           dispatch(setSnackbar(true, "error", err.response.data.error));
//         });
//     };
//     const getSuAccData = () => {
//       axios
//         .get(`/v1/subaccounts`)
//         .then((res) => {
//           //   console.log(res.data)
//           setSubAcHeadData(res.data);
//         })
//         .catch((err) => {
//           console.log(err);
//           dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
//         });
//     };
  
//     const getDocno = () => {
//       axios
//         .get(`/v1/expences/docno/1`)
//         // .get(`/v1/outlet_expences/${outletId}`)
//         .then((res) => {
//           setDocNo(res.data.Docno);
//         })
//         .catch((err) => {
//           console.log(err);
//           dispatch(setSnackbar(true, "error", err.response.data.error));
//         });
//     };
//     const handleSubmitData = () => {
//       const modifiedData = data.map((item) => {
//         const { accname, expences_details, ...rest } = item;
//         const modifiedExpencesDetails = expences_details.map((detail) => {
//           const { sub_acc_name, ...detailWithoutSubAccName } = detail;
//           return detailWithoutSubAccName;
//         });
  
//         return {
//           ...rest,
//           expences_details: modifiedExpencesDetails,
//         };
//       });
  
//       console.log(modifiedData);
//       axios
//         .post(`/v1/expences/with_expences_details`, modifiedData)
//         .then((res) => {
//           console.log(res);
//           getExpensesData();
//           setDocNo("");
//           getDocno();
//           setOpen(false);
//           // setTimeout(() => {
//           //   window.location.reload();
//           // }, 1000);
//           dispatch(setSnackbar(true, "success", "Bill Saved Successfully"));
//         })
//         .catch((err) => {
//           console.log(err);
//           dispatch(setSnackbar(true, "error", err.response?.data?.errors[0]?.message || "Failed to save bill"));

//         });
     
//     };
//     const getExpensesData = () => {
//       const getExpData = {
//         from_date : poDetails.fromDate,
//         to_date: poDetails.toDate,
//       }
//       axios.post( `/v1/expences/with_expences_details_get`,getExpData)
//         .then((res) => {
//           console.log(res.data);
//           setPageCount(res.data.length);
//           setTableData(res.data);
//         })
//         .catch((err) => {
//           console.log(err);
//           // dispatch(setSnackbar(true, "error", "No Data found"));
//         });
//     };
//     const handleDelete =(row)=> {
//       console.log("Row data:", row);
//       setOpenDialog(false)
//       setActiveId(null)
//       const deleteRow = {
//         expences_id:row.id,
//         // outlet_expences_id:row.id,
//         // outlet_id :outletId,
//         warehouse_id:1,
//         acc_id :row.accid,
//         edate :row.docDate,
//         total_amount :parseFloat(row.tot_amt).toFixed(2)

//         // "expences_id": 2,
//         // "warehouse_id": 1,
//         // "acc_id": 30,
//         // "edate": "2024-11-22",
//         // "total_amount": 10000
//       }
//       console.log(deleteRow)
//       axios.post(`/v1/expences/with_expences_details/delete`,deleteRow)
//       .then((res) => {
//         console.log(res)
//         dispatch(setSnackbar(true , "success" , "Deleted successfully"))
//         getExpensesData()
//       })
//       .catch((err) => {
//         console.log(err)
//       })
//     }
//     useEffect(() => {
//       getSupplierData();
//       getDocno();
//       getSuAccData();
//     }, []);
//     useEffect(() => {
//       getExpensesData();
//       setTablePostData((prev) => ({
//         ...prev,
//         docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
//         headName: poDetails.acHead ? poDetails.acHead.acname : "",
//         amount: poDetails.amount,
//         remarks: poDetails.remarks,
//         company_id: 1,
//         outletid: outletId,
//         subHeadName: poDetails.subAcHead
//           ? poDetails.subAcHead.sub_account_name
//           : "",
//         headId: poDetails.acHead ? poDetails.acHead.id : "",
//         subHeadId: poDetails.subAcHead ? poDetails.subAcHead.id : "",
//       }));
//       setPostData((prevState) => ({
//         ...prevState,
//         docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
//         accid: poDetails.acHead ? poDetails.acHead.id : "",
//         amount: poDetails.amount,
//         remarks: poDetails.remarks,
//         company_id: 1,
//         outletid: outletId,
//         sub_acc_id: poDetails.subAcHead ? poDetails.subAcHead.id : "",
//       }));
//     }, [poDetails]);
//     const handleDeleteRow = (entryIndex, detailIndex) => {
//       const newData = [...data];
//       const entry = newData[entryIndex];
  
//       // Update the total amount
//       const deletedAmount = entry.expences_details[detailIndex].amount;
//       const remainingDetails = entry.expences_details.filter(
//         (_, idx) => idx !== detailIndex
//       );
//       const newAmount = remainingDetails.reduce(
//         (sum, detail) => sum + detail.amount,
//         0
//       );
  
//       entry.expences_details.splice(detailIndex, 1);
//       entry.amount = newAmount;
  
//       // If there are no more details, remove the entire entry
//       if (entry.expences_details.length === 0) {
//         newData.splice(entryIndex, 1);
//       }
  
//       setData(newData);
//     };
//     const transformData = (data) => {
//       return data.reduce((acc, entry, entryIndex) => {
//         entry.expences_details.forEach((detail, detailIndex) => {
//           acc.push({
//             index: acc.length + 1,
//             accname: entry.accname,
//             sub_acc_name: detail.sub_acc_name,
//             amount: detail.amount,
//             remarks: entry.remarks,
//             entryIndex,
//             detailIndex,
//           });
//         });
//         return acc;
//       }, []);
//     };
  
//     const transformedData = transformData(data);
  
//     console.log(data);
//     return (
//       <Grid className={classes.root}>
//         <Helmet>
//           <title>Expenses Entry</title>
//         </Helmet>
//         <Grid className={classes.titleInfo}>
//           <Typography variant="h5" fontWeight={600}>
//             Expenses Entry
//           </Typography>
//         </Grid>
//         {!open && (
//           <Grid className="flex justify-end mt-2">
//             <Button variant="contained" onClick={onCreate}>
//               Create New
//             </Button>
//           </Grid>
//         )}
//         {open && (
//           <Grid container spacing={2} className="p-4 h-1/2">
//             <Grid item xs={12} className="justify-end" textAlign={"right"}>
//               <Button
//                 variant="outlined"
//                 onClick={() => {
//                   setOpen(false);
//                   formik.resetForm();
//                   setPoDetails(initialPoDetails);
//                 }}
//               >
//                 Close
//               </Button>
//             </Grid>
//             <Grid xs={12} md={6} lg={6} sx={{marginBlockEnd:3}}>
//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <DatePicker
//                   onChange={(e) => handleChange(e, "docDate")}
//                   disabled
//                   value={dayjs(poDetails.docDate)}
//                   label="Doc Date"
//                   slotProps={{
//                     textField: {
//                       size: "small",
//                     },
//                   }}
//                 />
//               </LocalizationProvider>
//             </Grid>
//             <Grid xs={12} md={6} lg={6} sx={{marginBlockEnd:3}}>
//               <TextField
//                 size="small"
//                 label="Doc NO"
//                 value={docNo
//                   .replace("_", "/")
//                   .replace("_", "-")
//                   .replace("_", "/")
//                   .replace("_", "/")}
//               />
//             </Grid>
//             <Grid xs={12} md={3} lg={3}>
//               <Autocomplete
//                 id="headName"
//                 name="headName"
//                 size="small"
//                 options={acHeadData}
//                 value={formik.values.headName}
//                 sx={{ marginInline: 1 }}
//                 getOptionLabel={(option) => option?.acname}
//                 onChange={(event, newValue) =>
//                   formik.setFieldValue("headName", newValue)
//                 }
//                 disableClearable
//                 // isOptionEqualToValue={(option, value) =>
//                 // option.acname === value.acname
//                 // }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Expense Name"
//                     autoComplete="off"
//                     // required
//                     error={
//                       formik.touched.headName && Boolean(formik.errors.headName)
//                     }
//                     helperText={formik.touched.headName && formik.errors.headName}
//                   />
//                 )}
//               />
//             </Grid>
           
//             <Grid xs={12} md={3} lg={3}>
//               <Autocomplete
//                 id="subName"
//                 name="subName"
//                 size="small"
//                 options={subAcHeadData.filter(
//                   (val) =>
//                     formik.values.headName &&
//                     val.acc_id === formik.values.headName.id
//                 )}
//                 sx={{ marginInline: 1 }}
//                 value={formik.values.subName}
//                 getOptionLabel={(option) => option?.sub_account_name}
//                 onChange={(event, newValue) =>
//                   formik.setFieldValue("subName", newValue)
//                 }
//                 disableClearable
//                 disabled={formik.values.headName === null}
//                 // isOptionEqualToValue={(option, value) =>
//                 // option.sub_account_name === value.sub_account_name
//                 // }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Expense Sub Name"
//                     autoComplete="off"
//                     // required
//                     error={
//                       formik.touched.subName && Boolean(formik.errors.subName)
//                     }
//                     helperText={formik.touched.subName && formik.errors.subName}
//                   />
//                 )}
//               />
//             </Grid>
//             <Grid xs={12} md={3} lg={3}>
//               <TextField
//                 id="amount"
//                 name="amount"
//                 size="small"
//                 label="Amount"
//                 fullWidth
//                 onChange={formik.handleChange}
//                 value={formik.values.amount}
//                 error={formik.touched.amount && Boolean(formik.errors.amount)}
//                 helperText={formik.touched.amount && formik.errors.amount}
//               />
//             </Grid>
//             <Grid item xs={12} md={3} lg={3}  sx={{ display:"flex",padding: "0px !important" }}>
//             <Button
//                 variant="contained"
//                 sx={{ marginInline: 3 }}
//                 onClick={formik.handleSubmit}
//               >
//                 Add
//               </Button>
//             </Grid>
  
//             {/* <Grid item xs={12} sx={{display:"flex",justifyContent:"flex-end"}}>
             
//             </Grid> */}
//             {data.length > 0 && (
//               <Grid item xs={12}>
//                 <TableContainer className={classes.tblRoot}>
//                   <Table className={classes.table}>
//                     <TableHead
//                       className={classes.tblHeader}
//                       sx={{ backgroundColor: "#A06EE1", color: "#fff" }}
//                     >
//                       <TableRow className={classes.tablrow}>
//                         <TableCell>S.no</TableCell>
//                         <TableCell>Head Name</TableCell>
//                         <TableCell>SubHead Name</TableCell>
//                         <TableCell>Amount</TableCell>
//                         {/* <TableCell>Remarks</TableCell> */}
//                         <TableCell>Action</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {transformedData.map((entry, index) => (
//                         <TableRow key={index}>
//                           <TableCell className={classes.tblContentCellBorder}>
//                             {index + 1}
//                           </TableCell>
//                           <TableCell className={classes.tblContentCellBorder}>
//                             {entry.accname}
//                           </TableCell>
//                           <TableCell className={classes.tblContentCellBorder}>
//                             {entry.sub_acc_name}
//                           </TableCell>
//                           <TableCell className={classes.tblContentCellBorder}>
//                             {entry.amount}
//                           </TableCell>
//                           {/* <TableCell className={classes.tblContentCellBorder}>
//                             {entry.remarks}
//                           </TableCell> */}
//                           <TableCell
//                             className={classes.tblContentCellBorder}
//                             sx={{ borderRight: "1px solid #ccc" }}
//                           >
//                             <IconButton
//                               onClick={() =>
//                                 handleDeleteRow(
//                                   entry.entryIndex,
//                                   entry.detailIndex
//                                 )
//                               }
//                             >
//                               <Delete sx={{ color: "red" }} />
//                             </IconButton>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             )}
//             <Grid xs={12}>
//                 <TextField
//                   id="remarks"
//                   name="remarks"
//                   size="small"
//                   multiline
//                   rows={4}
//                   value={formik.values.remarks}
//                   sx={{marginInline:1,maxWidth:"400px",marginBlock:2}}
//                   label="Remarks"
//                   fullWidth
//                   onChange={formik.handleChange}
//                   error={formik.touched.remarks && Boolean(formik.errors.remarks)}
//                   helperText={formik.touched.remarks && formik.errors.remarks}
//                 />
//             </Grid>
//             <Grid item xs={12} sx={{ textAlign: "right" }}>
//               {data.length > 0 && (
//                 <Button
//                   size="small"
//                   sx={{ margin: 1 }}
//                   startIcon={<Save />}
//                   variant="outlined"
//                   onClick={handleSubmitData}
//                 >
//                   Save
//                 </Button>
//               )}
//               {/* {isEdit ? (
//                 <Button
//                   size="small"
//                   sx={{ margin: 1 }}
//                   startIcon={<Save />}
//                   variant="outlined"
//                   onClick={handleUpdate}
//                 >
//                   Update
//                 </Button>
//               ) : (
//                 <Button
//                   size="small"
//                   sx={{ margin: 1 }}
//                   startIcon={<Save />}
//                   variant="outlined"
//                   onClick={handleSubmitData}
//                 >
//                   Save
//                 </Button>
//               )} */}
//             </Grid>
//             <Grid item xs={12}>
//               <Divider />
//             </Grid>
//           </Grid>
//         )}
//         <div className="flex px-4">
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               format="DD-MM-YYYY"
//               value={dayjs(poDetails.fromDate)}
//               label="From Date"
//               slotProps={{
//                 textField: {
//                   size: "small",
//                 },
//               }}
//               sx={{ marginBlock: 1.5, marginInlineEnd: 2 }}
//             />
//           </LocalizationProvider>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               format="DD-MM-YYYY"
//               value={dayjs(poDetails.toDate)}
//               label="To Date"
//               slotProps={{
//                 textField: {
//                   size: "small",
//                 },
//               }}
//               sx={{ marginBlock: 1.5 }}
//             />
//           </LocalizationProvider>
//         </div>
//         <div>
//           <CustomDataGrid props={props} />
//         </div>
//         <Backdrop open={openTable} sx={{zIndex:1450}}>
//           <ExpModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpenTable} data={rowData}/>
//         </Backdrop>
//         <Backdrop open={openDialog} sx={{zIndex:1350}}>
//   <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
// </Backdrop>
       
//       </Grid>
//     ); 
//   };
  
//   export default DummyWh;
  

import {
  Delete,
  Save
} from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Autocomplete,
  Backdrop,
  Button,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import dayjs from "dayjs";
import { useFormik } from "formik";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import ExpModalTable from "../../../../../components/utils/modalTable/expenseTable";
import { useStyle } from "../../outlets/style";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";

const DummyWh = () => {
  const classes = useStyle();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outletId = localStorage.getItem("outlet_id");
  const [open, setOpen] = useState(false);
  const [openTable, setOpenTable] = useState(false);
  const [rowData, setRowData] = useState(null)
  const [isEdit, setIsEdit] = useState(false);
  const [acHeadData, setAcHeadData] = useState([]);
  const [subAcHeadData, setSubAcHeadData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0)
  const [totalFlag, setTotalFlag] = useState(false)
  const sendData = {
    docdate: "",
    accid: 0,
    amount: 0,
    remarks: "",
    company_id: 1,
    outlet_expences_details: [],
  };
  const [docNo, setDocNo] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const pageOption = [10, 25, 50, 100];
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [data, setData] = useState([]);
  const [expDataLine, setExpDataLine] = useState([])
  const wareHouseId = localStorage.getItem('userId')
  const [openDialog, setOpenDialog] = useState(false)

  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    acHead: null,
    subAcHead: null,
    amount: "",
    remarks: "",
    fromDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  });
  const [tablePostData, setTablePostData] = useState({
    headName: null,
    subHeadName: null,
    amount: "",
    remarks: "",
    headId: null,
    subHeadId: null,
  });
  const [postData, setPostData] = useState([]);

  const initialPoDetails = {
    docDate: moment().format(),
    acHead: null,
    amount: "",
    remarks: "",
    fromDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  const validationSchema = yup.object({
    headName: yup.object().required(),
    subName: yup.object().required(),
    amount: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .required("This field can't be empty!"),
    remarks: yup.string().notRequired("This field can't be empty!"),
  });

  const formik = useFormik({
    initialValues: {
      headName: null,
      subName: null,
      amount: "",
      remarks: "",
    },
    validationSchema: validationSchema,
    onSubmit: addTable,
  });

  const resetPoDetails = () => {
    setPoDetails(initialPoDetails);
  };

  function addTable() {
    const arr = [...data];
    const selectedHead = acHeadData.find(
      (head) => head.id === formik.values.headName.id
    );
    const selectedSubHead = subAcHeadData.find(
      (subHead) => subHead.id === formik.values.subName.id
    );
    const newRemarks = formik.values.remarks;

    const objData = {
      docdate: moment().format("YYYY-MM-DD"),
      accid: formik.values.headName.id,
      accname: selectedHead ? selectedHead.acname : "",
      amount: parseFloat(formik.values.amount),
      remarks: newRemarks,
      company_id: 1,
      warehouse_id: 1,
      expences_details: [
        {
          docdate: "2024-05-30",
          accid: formik.values.headName.id,
          sub_acc_id: formik.values.subName.id,
          amount: parseFloat(formik.values.amount),
          sub_acc_name: selectedSubHead ? selectedSubHead.sub_account_name : "",
        },
      ],
    };

    const existingHeadIndex = arr.findIndex(
      (val) => val.accid == objData.accid
    );

    if (existingHeadIndex === -1) {
      arr.push(objData);
    } else {
      const existingSubIndex = arr[
        existingHeadIndex
      ].expences_details.findIndex(
        (item) => item.sub_acc_id == objData.expences_details[0].sub_acc_id
      );

      if (existingSubIndex === -1) {
        arr[existingHeadIndex].expences_details.push(
          objData.expences_details[0]
        );
      } else {
        arr[existingHeadIndex].expences_details[existingSubIndex].amount +=
          objData.expences_details[0].amount;
      }

      arr[existingHeadIndex].remarks = newRemarks;
      arr[existingHeadIndex].expences_details.forEach((sub) => {
        sub.remarks = newRemarks;
      });

      arr[existingHeadIndex].amount = arr[
        existingHeadIndex
      ].expences_details.reduce((total, item) => total + item.amount, 0);
    }

    setData(arr);
    formik.resetForm();
    console.log(arr);
  }

  const onCreate = () => {
    setOpen(true);
    setIsEdit(false);
  };
  const onEdit = (row) => {
    setExpDataLine(row.expenseLine)
    setOpenTable(true)
    setRowData(row)
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "docNo",
      headerName: "Bill No",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "docDates",
      headerName: "Bill Date",
      minWidth: 170,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "acName",
      headerName: "Expense Name",
      minWidth: 190,
      flex: 1,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 170,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "remarks",
      headerName: "Remarks",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      renderCell: (params) => (
        <div className="flex justify-center w-full">
          <IconButton onClick={() => onEdit(params.row)}>
            <VisibilityIcon sx={{ fontSize: 22 }} />
          </IconButton>
          <IconButton onClick={() => OnDelete(params.row)}>
            <DeleteIcon sx={{ color: "red", fontSize: 22 }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(tableData, (val, idx) => ({
    id: val.id,
    sno: ++idx,
    docNo: val.docno
      .replace("_", "/")
      .replace("_", "-")
      .replace("_", "/")
      .replace("_", "/") || "-",
    documentNo: val.docno,
    docDates: moment(val.docdate).format("DD-MM-YYYY"),
    documentDate: moment(val.docdate).format("DD-MM-YYYY"),
    docDate: moment(val.docdate).format("YYYY-MM-DD"),
    accid: val.accid || "-",
    amount: val.amount || "-",
    tot_amt: val.amount || "",
    remarks: val.remarks || "-",
    acName: val.account_name || "-",
    sub_account_name: val.sub_account_name || "-",
    expenseLine: val.expences_lines,
  }));

  const tableHeadData = [
    { id: 1, label: "S No" },
    { id: 2, label: "Date" },
    { id: 3, label: "Sub Account Name" },
    { id: 4, label: "Amount" },
  ];

  const tableBodyData = _.map(expDataLine, (val, idx) => ({
    id: idx,
    sNo: idx + 1,
    name: moment(val.created_at).format('DD-MM-YYYY'),
    Mrp: val.sub_account_name,
    gstAmnt: val.amount,
    Rate: val.rate,
    totalAmount: parseFloat(val.qty * val.rate).toFixed(2)
  }));

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };

  function OnDelete(row) {
    setOpenDialog(true)
    setActiveId(row)
  }

  const handleAutocompleteChange = (newValue) => {
    setPoDetails((prevState) => ({ ...prevState, acHead: newValue }));
  };

  const handleAutocompleteChangeSub = (newValue) => {
    setPoDetails((prevState) => ({ ...prevState, subAcHead: newValue }));
  };

  const handleChange = (e, name) => {
    if (name === "docDate") {
      setPoDetails((prevState) => ({
        ...prevState,
        [name]: dayjs(e).format(),
      }));
    } else if (name === "fromDate" || name === "toDate") {
      setPoDetails((prevState) => ({
        ...prevState,
        [name]: dayjs(e).format("YYYY-MM-DD"),
      }));
    } else {
      setPoDetails((prevState) => ({ ...prevState, [name]: e }));
    }
  };

  const getSupplierData = () => {
    axios
      .get(`/v1/accountmaster`)
      .then((res) => {
        setAcHeadData(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  };

  const getSuAccData = () => {
    axios
      .get(`/v1/subaccounts`)
      .then((res) => {
        setSubAcHeadData(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
      });
  };

  const getDocno = () => {
    axios
      .get(`/v1/expences/docno/1`)
      .then((res) => {
        setDocNo(res.data.Docno);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  };

  const handleSubmitData = () => {
    const modifiedData = data.map((item) => {
      const { accname, expences_details, ...rest } = item;
      const modifiedExpencesDetails = expences_details.map((detail) => {
        const { sub_acc_name, ...detailWithoutSubAccName } = detail;
        return detailWithoutSubAccName;
      });

      return {
        ...rest,
        expences_details: modifiedExpencesDetails,
      };
    });

    axios
      .post(`/v1/expences/with_expences_details`, modifiedData)
      .then((res) => {
        getExpensesData();
        setDocNo("");
        getDocno();
        setOpen(false);
        dispatch(setSnackbar(true, "success", "Bill Saved Successfully"));
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response?.data?.errors[0]?.message || "Failed to save bill"));
      });
  };

  const getExpensesData = () => {
    const getExpData = {
      from_date: poDetails.fromDate,
      to_date: poDetails.toDate,
    }
    axios.post(`/v1/expences/with_expences_details_get`, getExpData)
      .then((res) => {
        setPageCount(res.data.length);
        setTableData(res.data);
      })
      .catch((err) => {
        /** silent */
      });
  };

  // THIS IS THE UPDATED DELETE LOGIC
  const handleDelete = (row) => {
    setOpenDialog(false)
    setActiveId(null)
    const deleteRow = {
      expences_id: row.id,
      warehouse_id: 1,
      acc_id: row.accid,
      edate: row.docDate,
      total_amount: parseFloat(row.tot_amt).toFixed(2)
    }

    axios.post(`/v1/expences/with_expences_details/delete`, deleteRow)
      .then((res) => {
        dispatch(setSnackbar(true, "success", "Deleted successfully"));
        // Update UI instantly by filtering out the deleted row
        setTableData(prevData => prevData.filter(item => item.id !== row.id));
        setPageCount(prev => (prev > 0 ? prev - 1 : 0));
      })
      .catch((err) => {
        /** silent */
      })
  }

  useEffect(() => {
    getSupplierData();
    getDocno();
    getSuAccData();
  }, []);
  useEffect(() => {
    getExpensesData();
    setTablePostData((prev) => ({
      ...prev,
      docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
      headName: poDetails.acHead ? poDetails.acHead.acname : "",
      amount: poDetails.amount,
      remarks: poDetails.remarks,
      company_id: 1,
      outletid: outletId,
      subHeadName: poDetails.subAcHead
        ? poDetails.subAcHead.sub_account_name
        : "",
      headId: poDetails.acHead ? poDetails.acHead.id : "",
      subHeadId: poDetails.subAcHead ? poDetails.subAcHead.id : "",
    }));
    setPostData((prevState) => ({
      ...prevState,
      docdate: moment(poDetails.docDate).format("YYYY/MM/DD"),
      accid: poDetails.acHead ? poDetails.acHead.id : "",
      amount: poDetails.amount,
      remarks: poDetails.remarks,
      company_id: 1,
      outletid: outletId,
      sub_acc_id: poDetails.subAcHead ? poDetails.subAcHead.id : "",
    }));
  }, [poDetails]);

  const handleDeleteRow = (entryIndex, detailIndex) => {
    const newData = [...data];
    const entry = newData[entryIndex];

    const remainingDetails = entry.expences_details.filter(
      (_, idx) => idx !== detailIndex
    );
    const newAmount = remainingDetails.reduce(
      (sum, detail) => sum + detail.amount,
      0
    );

    entry.expences_details.splice(detailIndex, 1);
    entry.amount = newAmount;

    if (entry.expences_details.length === 0) {
      newData.splice(entryIndex, 1);
    }

    setData(newData);
  };

  const transformData = (data) => {
    return data.reduce((acc, entry, entryIndex) => {
      entry.expences_details.forEach((detail, detailIndex) => {
        acc.push({
          index: acc.length + 1,
          accname: entry.accname,
          sub_acc_name: detail.sub_acc_name,
          amount: detail.amount,
          remarks: entry.remarks,
          entryIndex,
          detailIndex,
        });
      });
      return acc;
    }, []);
  };

  const transformedData = transformData(data);

  return (
    <Grid className={classes.root}>
      <Helmet>
        <title>Expenses Entry</title>
      </Helmet>
      <Grid className={classes.titleInfo}>
        <Typography variant="h5" fontWeight={600}>
          Expenses Entry
        </Typography>
      </Grid>
      {!open && (
        <Grid className="flex justify-end mt-2">
          <Button variant="contained" onClick={onCreate}>
            Create New
          </Button>
        </Grid>
      )}
      {open && (
        <Grid container spacing={2} className="p-4 h-1/2">
          <Grid item xs={12} className="justify-end" textAlign={"right"}>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
                formik.resetForm();
                setPoDetails(initialPoDetails);
              }}
            >
              Close
            </Button>
          </Grid>
          <Grid xs={12} md={6} lg={6} sx={{ marginBlockEnd: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                onChange={(e) => handleChange(e, "docDate")}
                disabled
                value={dayjs(poDetails.docDate)}
                label="Doc Date"
                slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={12} md={6} lg={6} sx={{ marginBlockEnd: 3 }}>
            <TextField
              size="small"
              label="Doc NO"
              value={docNo
                .replace("_", "/")
                .replace("_", "-")
                .replace("_", "/")
                .replace("_", "/")}
            />
          </Grid>
          <Grid xs={12} md={3} lg={3}>
            <Autocomplete
              id="headName"
              name="headName"
              size="small"
              options={acHeadData}
              value={formik.values.headName}
              sx={{ marginInline: 1 }}
              getOptionLabel={(option) => option?.acname}
              onChange={(event, newValue) =>
                formik.setFieldValue("headName", newValue)
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Expense Name"
                  autoComplete="off"
                  error={
                    formik.touched.headName && Boolean(formik.errors.headName)
                  }
                  helperText={formik.touched.headName && formik.errors.headName}
                />
              )}
            />
          </Grid>
          <Grid xs={12} md={3} lg={3}>
            <Autocomplete
              id="subName"
              name="subName"
              size="small"
              options={subAcHeadData.filter(
                (val) =>
                  formik.values.headName &&
                  val.acc_id === formik.values.headName.id
              )}
              sx={{ marginInline: 1 }}
              value={formik.values.subName}
              getOptionLabel={(option) => option?.sub_account_name}
              onChange={(event, newValue) =>
                formik.setFieldValue("subName", newValue)
              }
              disableClearable
              disabled={formik.values.headName === null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Expense Sub Name"
                  autoComplete="off"
                  error={
                    formik.touched.subName && Boolean(formik.errors.subName)
                  }
                  helperText={formik.touched.subName && formik.errors.subName}
                />
              )}
            />
          </Grid>
          <Grid xs={12} md={3} lg={3}>
            <TextField
              id="amount"
              name="amount"
              size="small"
              label="Amount"
              fullWidth
              onChange={formik.handleChange}
              value={formik.values.amount}
              error={formik.touched.amount && Boolean(formik.errors.amount)}
              helperText={formik.touched.amount && formik.errors.amount}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={3} sx={{ display: "flex", padding: "0px !important" }}>
            <Button
              variant="contained"
              sx={{ marginInline: 3 }}
              onClick={formik.handleSubmit}
            >
              Add
            </Button>
          </Grid>
          {data.length > 0 && (
            <Grid item xs={12}>
              <TableContainer className={classes.tblRoot}>
                <Table className={classes.table}>
                  <TableHead
                    className={classes.tblHeader}
                    sx={{ backgroundColor: "#A06EE1", color: "#fff" }}
                  >
                    <TableRow className={classes.tablrow}>
                      <TableCell>S.no</TableCell>
                      <TableCell>Head Name</TableCell>
                      <TableCell>SubHead Name</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transformedData.map((entry, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tblContentCellBorder}>
                          {index + 1}
                        </TableCell>
                        <TableCell className={classes.tblContentCellBorder}>
                          {entry.accname}
                        </TableCell>
                        <TableCell className={classes.tblContentCellBorder}>
                          {entry.sub_acc_name}
                        </TableCell>
                        <TableCell className={classes.tblContentCellBorder}>
                          {entry.amount}
                        </TableCell>
                        <TableCell
                          className={classes.tblContentCellBorder}
                          sx={{ borderRight: "1px solid #ccc" }}
                        >
                          <IconButton
                            onClick={() =>
                              handleDeleteRow(
                                entry.entryIndex,
                                entry.detailIndex
                              )
                            }
                          >
                            <Delete sx={{ color: "red" }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
          <Grid xs={12}>
            <TextField
              id="remarks"
              name="remarks"
              size="small"
              multiline
              rows={4}
              value={formik.values.remarks}
              sx={{ marginInline: 1, maxWidth: "400px", marginBlock: 2 }}
              label="Remarks"
              fullWidth
              onChange={formik.handleChange}
              error={formik.touched.remarks && Boolean(formik.errors.remarks)}
              helperText={formik.touched.remarks && formik.errors.remarks}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            {data.length > 0 && (
              <Button
                size="small"
                sx={{ margin: 1 }}
                startIcon={<Save />}
                variant="outlined"
                onClick={handleSubmitData}
              >
                Save
              </Button>
            )}
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
      )}
      <div className="flex px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(e) => handleChange(e, "fromDate")}
            format="DD-MM-YYYY"
            value={dayjs(poDetails.fromDate)}
            label="From Date"
            slotProps={{
              textField: {
                size: "small",
              },
            }}
            sx={{ marginBlock: 1.5, marginInlineEnd: 2 }}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(e) => handleChange(e, "toDate")}
            format="DD-MM-YYYY"
            value={dayjs(poDetails.toDate)}
            label="To Date"
            slotProps={{
              textField: {
                size: "small",
              },
            }}
            sx={{ marginBlock: 1.5 }}
          />
        </LocalizationProvider>
      </div>
      <div>
        <CustomDataGrid props={props} />
      </div>
      <Backdrop open={openTable} sx={{ zIndex: 1450 }}>
        <ExpModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpenTable} data={rowData}/>
      </Backdrop>
      <Backdrop open={openDialog} sx={{ zIndex: 1350 }}>
        <DeletePage onCancel={setOpenDialog} onSubmit={() => handleDelete(activeId)}/>
      </Backdrop>      
    </Grid>
  );
};

export default DummyWh;
